export const NEW_YEAR_KEY = 'НОВОГОДНИЕ'
export const MAY_HOLIDAYS_KEY = 'МАЙСКИЕ'
export const STATUS_CONFIG: { [key: string]: string } = {
    Standard: 'Стандартный',
    Worksheet: 'Черновик',
    Approved: 'Утвержден'
}
export const AMERICAN_DATE_FORMAT = 'MM.DD.YYYY'
export const RUSSIAN_SHORT_DATE_FORMAT = 'DD.MM.YY'
export const DAY_STRING_FORMAT = 'dddd'
export const DELAY_BEFORE_AVAILABLE_DAYS = 1
